import React from "react";
import QRGenerator from "./components/QRGenerator";

function App() {
  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Background Decorations */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
        <div className="absolute top-[-20%] left-[-15%] w-[50%] h-[50%] bg-blue-400/15 rounded-full blur-[100px]" />
        <div className="absolute bottom-[-20%] right-[-15%] w-[50%] h-[50%] bg-emerald-400/15 rounded-full blur-[100px]" />
        <div className="absolute top-[40%] right-[-10%] w-[30%] h-[30%] bg-violet-400/10 rounded-full blur-[80px]" />
      </div>

      <div className="relative z-10 min-h-screen flex flex-col">
        {/* Header */}
        <header className="px-4 sm:px-6 lg:px-8 pt-8 sm:pt-12 pb-6 sm:pb-10 text-center animate-fade-in-up">
          <div className="max-w-2xl mx-auto">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-blue-50 border border-blue-100 mb-5">
              <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
              <span className="text-xs sm:text-sm font-semibold text-blue-700">Free &amp; Open Source</span>
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black bg-gradient-to-r from-blue-600 via-blue-500 to-emerald-500 bg-clip-text text-transparent leading-tight mb-3 sm:mb-4">
              Custom QR Generator
            </h1>
            <p className="text-slate-500 text-sm sm:text-base md:text-lg font-medium max-w-lg mx-auto leading-relaxed">
              Design professional, eye-catching QR codes with custom colors, patterns, and your own logo.
            </p>
          </div>
        </header>

        {/* Main Content */}
        <main className="flex-1 px-4 sm:px-6 lg:px-8 pb-8">
          <QRGenerator />
        </main>

        {/* Footer */}
        <footer className="px-4 sm:px-6 lg:px-8 py-6 sm:py-8 text-center border-t border-slate-100/50">
          <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-slate-400 text-xs sm:text-sm font-medium">
              Custom QR Generator
            </p>
            <p className="text-slate-300 text-xs font-medium">
              High-quality QR codes, always free
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default App;
